import { RiStarSFill, RiStarHalfSFill } from "react-icons/ri";

type StarRatingProps = {
  score: number; isSmallCard?: boolean; isPosterPage?: boolean;
}

export default function StarRating({ score, isSmallCard = false, isPosterPage = false }: StarRatingProps) {
  const fullStars = Math.floor(score);
  const hasHalfStar = score % 1 !== 0;

  return (
    <div className="flex">
      {[...Array(fullStars)].map((_, i) => (
        <RiStarSFill key={i} className={`text-amber-500 ${isSmallCard ? "text-sm sm:text-xl " : isPosterPage ? "text-lg sm:text-2xl" : "text-lg sm:text-2xl"}`} />
      ))}

      {/* Half star */}
      {hasHalfStar && (
        <RiStarHalfSFill className={`text-amber-500 ${isSmallCard ? "text-sm sm:text-xl " : isPosterPage ? "text-lg sm:text-2xl" : "text-lg sm:text-2xl"}`} />
      )}
    </div>
  );
};